import React, { useMemo } from "react";
import {
  BOARD_DIM_OPTIONS,
  cellColor,
  createBoardLayout,
  linksPerKind,
  squareLabel,
} from "../../../functions/boardLayout";

export default function BoardColorPanel({
  color1,
  color2,
  color3,
  boardCols,
  boardRows,
  onChangeColor,
  onChangeBoardCols,
  onChangeBoardRows,
  onSave,
  isSaving,
}) {
  const layout = useMemo(
    () => createBoardLayout({ cols: boardCols, rows: boardRows }),
    [boardCols, boardRows]
  );
  const perKind = linksPerKind(layout.size);

  return (
    <div className="themeupdate-card sl-color-panel" data-tour="tour-gc-board-color">
      <h2 className="themeupdate-card-title">Board Size &amp; Colour</h2>

      <div className="sl-color-pickers">
        <label className="sl-color-drop">
          <span>Columns:</span>
          <select
            className="sl-board-size-select"
            value={layout.cols}
            onChange={(e) => onChangeBoardCols(Number(e.target.value))}
          >
            {BOARD_DIM_OPTIONS.map((dim) => (
              <option key={`cols-${dim}`} value={dim}>
                {dim}
              </option>
            ))}
          </select>
        </label>
        <label className="sl-color-drop">
          <span>Rows:</span>
          <select
            className="sl-board-size-select"
            value={layout.rows}
            onChange={(e) => onChangeBoardRows(Number(e.target.value))}
          >
            {BOARD_DIM_OPTIONS.map((dim) => (
              <option key={`rows-${dim}`} value={dim}>
                {dim}
              </option>
            ))}
          </select>
        </label>
        <label className="sl-color-drop">
          <span>color1:</span>
          <input
            type="color"
            value={color1}
            onChange={(e) => onChangeColor("color1", e.target.value)}
          />
        </label>
        <label className="sl-color-drop">
          <span>color2:</span>
          <input
            type="color"
            value={color2}
            onChange={(e) => onChangeColor("color2", e.target.value)}
          />
        </label>
        <label className="sl-color-drop">
          <span>color3:</span>
          <input
            type="color"
            value={color3}
            onChange={(e) => onChangeColor("color3", e.target.value)}
          />
        </label>
      </div>

      <p className="themeupdate-muted sl-board-size-hint">
        A {layout.cols} × {layout.rows} board has {layout.size} squares and
        carries {perKind} ladders and {perKind} snakes (max 7 × 7). Add at least{" "}
        {perKind} Ladder and {perKind} Snake questions, or a run will end early
        once a category runs out.
      </p>

      <h3 className="sl-asset-group-title">board view</h3>
      <div
        className="sl-board-preview"
        aria-label="Board colour preview"
        style={{
          gridTemplateColumns: `repeat(${layout.cols}, 1fr)`,
          aspectRatio: `${layout.cols} / ${layout.rows}`,
        }}
      >
        {layout.visualSquares.map((square) => (
          <div
            key={square}
            className="sl-board-cell"
            style={{
              backgroundColor: cellColor(
                layout,
                square,
                color1,
                color2,
                color3
              ),
            }}
          >
            <span>{squareLabel(layout, square)}</span>
          </div>
        ))}
      </div>

      <div className="sl-asset-actions">
        <button
          type="button"
          className="themeupdate-btn themeupdate-btn-success"
          onClick={onSave}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
}
